/*global
    jQuery
*/
(function ($) {
    var activeText = '';
    var activeItem = $('ul.nav-menu').find('li.active > a');

    $.each(activeItem, function(index, element) {
        var $el = $(element);
        if ( activeText == '' ) {
            activeText += $el.text();
        } else {
            activeText += ' > ' + $el.text();
        }
    });
    
    if (typeof activeText !== 'undefined' && activeText.length > 0) {
        $('div#mobile-menu-active-item').text(activeText);
    }
}(jQuery));
